/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React from "react";
import { useHistory } from "react-router-dom";

import useUserAgent from "../../../hooks/useUserAgent";
import useCreateUrl from "../../../hooks/useCreateUrl";
import { useCheckInData } from "../../../hooks/useCheckInData";

import { WebCheckinInnerDesktop } from "./WebCheckinInner.desktop";
import { WebCheckinInner as WebCheckinInnerMobile } from "./WebCheckinInner";

// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../../../store";
import { assert } from "../../../utils/assert";
import { groupLegsByAirlineReference } from "../../../utils/groupLegsByAirlineReference";
import { FilteredLegWithOpenedCheckIn } from "../../../utils/get-filtered-legs-with-opened-checkIn";

// https://experiment.booking.com/experiments/1735460?message=new_draft
export const WebCheckinInner: React.FC = () => {
  const { isMobile } = useUserAgent();
  const history = useHistory();
  const { createUrl } = useCreateUrl();
  const {
    order: { order }
    // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  } = useStore();

  assert(order);

  const { filteredLegs, segment, segmentIndex } = useCheckInData(order);

  if (filteredLegs.length === 0 || !segment || segmentIndex === undefined) {
    history.push(createUrl(`/booking/order-details/${order.orderToken}`));
    return null;
  }

  // in the variant of this fix experiment, we are grouping legs by PNR (which groupLegsByAirlineReference function takes care of)
  // instead of grouping them by VI (current base behavior with the getFilteredLegsWithOpenedCheckIn function in the useCheckInData hook)
  const airlineReferenceGroups = groupLegsByAirlineReference(order, segmentIndex, segment.legs);
  const filteredLegsWithOpenedCheckIn: FilteredLegWithOpenedCheckIn[] = [];
  airlineReferenceGroups.forEach((group) => {
    const checkinInfoForLeg = order.carrierCheckinInfo?.find(
      (checkinInfo) =>
        checkinInfo.legIdentifier.segmentIndex === segmentIndex &&
        checkinInfo.legIdentifier.legIndex === group.startLegIndex
    );

    if (checkinInfoForLeg) {
      filteredLegsWithOpenedCheckIn.push({
        leg: group.journeyLeg,
        checkinInfoForLeg
      });
    }
  });

  return isMobile ? (
    <WebCheckinInnerMobile
      order={order}
      segmentIndex={segmentIndex}
      segment={segment}
      filteredLegsWithOpenedCheckIn={filteredLegsWithOpenedCheckIn}
    />
  ) : (
    <WebCheckinInnerDesktop
      order={order}
      segmentIndex={segmentIndex}
      segment={segment}
      filteredLegsWithOpenedCheckIn={filteredLegsWithOpenedCheckIn}
    />
  );
};
